<div class="text-center footer-container" id="footer">
    <div class="padding-bottom-50">
        <div class="ui grid">
            <div class="one wide column"></div>
            <div class="fourteen wide column">
                <h4 class="text-white padding-top-40 padding-bottom-30 contact-title">Garage Schiltz Büderscheid</h4>
                <div class="ui three column stackable grid padding-bottom-10">
                    <div class="column">
                        <div class="ui middle aligned stackable grid">
                            <div class="four wide column"></div>
                            <div class="icon-container two wide column ">
                                <img class="icon" src="../../../../../assets/img/marker.png"/>
                            </div>
                            <div class="icon-text ten wide column ">
                                <p class="contact-data">2, Route de Wiltz L - 9643 Büderscheid-Wiltz</p>
                            </div>
                        </div>
                    </div>
                    <div class="column">
                        <div class="ui middle aligned stackable grid">
                            <div class="three wide column"></div>
                            <div class="icon-container three wide column ">
                                <img class="icon" src="../../../../../assets/img/mail.png"/>
                            </div>
                            <div class="icon-text ten wide column ">
                                <a href="mailto:garage@schiltz-buderscheid.lu" class="contact-data">garage@schiltz-buderscheid.lu</a>
                            </div>
                        </div>
                    </div>
                    <div class="column">
                        <div class="ui middle aligned stackable grid text-center">
                            <div class="two wide column"></div>
                            <div class="icon-container three wide column ">
                                <img class="icon" src="../../../../../assets/img/phone.png"/>
                            </div>
                            <div class="icon-text eleven wide column ">
                                <p class="contact-data">Phone: +352 26 88 90 75</p>
                                <p class="contact-data">Fax: +352 26 88 90 76</p>
                            </div>
                        </div>
                    </div>
                </div>
                <h4 class="text-white padding-bottom-10 contact-title">Horaires</h4>
                <div class="text-white schedule">
                    Du lundi au vendredi :<br>
                    De 07h45 à 12h00<br>
                    De 13h00 à 18h00<br>
                    <br>
                    Samedi :<br>
                    De 09h00 à 12h00<br>
                </div>

                <div class="separator"></div>

                <h4 class="text-white padding-top-10 padding-bottom-30 contact-title">Schiltz Voyages</h4>
                <div class="ui three column stackable grid padding-bottom-30">
                    <div class="column">
                        <div class="ui middle aligned stackable grid">
                            <div class="four wide column"></div>
                            <div class="icon-container two wide column ">
                                <img class="icon" src="../../../../../assets/img/marker.png"/>
                            </div>
                            <div class="icon-text ten wide column ">
                                <p class="contact-data">2, Route de Wiltz L - 9643 Büderscheid-Wiltz</p>
                            </div>
                        </div>
                    </div>
                    <div class="column">
                        <div class="ui middle aligned stackable grid">
                            <div class="three wide column"></div>
                            <div class="icon-container three wide column ">
                                <img class="icon" src="../../../../../assets/img/mail.png"/>
                            </div>
                            <div class="icon-text ten wide column">
                                <a href="mailto:voyages@schiltz-buderscheid.lu" class="contact-data">voyages@schiltz-buderscheid.lu</a>
                            </div>
                        </div>
                    </div>
                    <div class="column">
                        <div class="ui middle aligned stackable grid text-center">
                            <div class="two wide column"></div>
                            <div class="icon-container three wide column ">
                                <img class="icon" src="../../../../../assets/img/phone.png"/>
                            </div>
                            <div class="icon-text eleven wide column ">
                                <p class="contact-data">Phone: +352 26 88 97 88</p>
                                <p class="contact-data">Fax: +352 26 88 97 89</p>
                            </div>
                        </div>
                    </div>
                </div>

                <h4 class="text-white padding-bottom-10 contact-title">Horaires</h4>
                <div class="text-white schedule">
                    Du lundi au vendredi :<br>
                    De 07h45 à 12h00<br>
                    De 13h00 à 18h00<br>
                    <br>
                    Samedi :<br>
                    De 09h00 à 12h00<br>
                </div>

                <div class="separator margin-top-50 margin-bottom-50"></div>

                <contact></contact>
            </div>
            <div class="one wide column"></div>
        </div>
    </div>
    <div class="ui container">

    </div>
</div>



// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/presentation/components/garage/footer/footer.html